<template>
  <div class="banner-container bg-[#F4F1FF] py-6 mb-8 border-b border-gray-200">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center">
      <div
        :class="[
          'flex flex-col md:flex-row items-center justify-center w-full',
          singleInput ? 'md:w-[34rem] gap-4 max-w-3xl' : hasRightInput ? 'gap-4 max-w-5xl' : 'gap-4 max-w-4xl'
        ]"
      >
        <div
          :class="[
            'w-full',
            singleInput ? 'md:w-96' : hasRightInput ? 'md:w-96' : 'md:flex-1'
          ]"
        >
          <slot name="left-input" />
        </div>
        <div
          v-if="!singleInput && hasRightInput"
          class="w-full md:w-80"
        >
          <slot name="right-input" />
        </div>
        <div
          :class="[
            'w-full',
            hasRightInput ? 'md:w-32' : 'md:w-40'
          ]"
        >
          <slot name="action" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useSlots, computed, Comment } from 'vue'

const props = defineProps<{
  singleInput?: boolean
}>()
const slots = useSlots()
const hasRightInput = computed(() => {
  if (props.singleInput) return false
  const rightSlot = slots['right-input']
  if (!rightSlot) return false
  const content = rightSlot()
  if (!content || content.length === 0) return false
  return content.some((vnode: any) => {
    if (typeof vnode.children === 'string') {
      return vnode.children.trim().length > 0
    }
    return vnode.type !== Comment
  })
})
</script>

<style scoped>
.banner-container {
  box-sizing: border-box;
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
}

:global(html) {
  overflow-x: hidden;
}
</style>
